'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled, { css } from 'styled-components';

var ChipWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    padding: 2px 8px;\n    font-weight: 500;\n    line-height: 20px;\n    border-radius: 14px;\n    display: inline-flex;\n    align-items: center;\n    ", ";\n"], ["\n    background-color: ", ";\n    color: ", ";\n    padding: 2px 8px;\n    font-weight: 500;\n    line-height: 20px;\n    border-radius: 14px;\n    display: inline-flex;\n    align-items: center;\n    ", ";\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var isHaveIcon = _a.isHaveIcon;
    if (!isHaveIcon) {
        return '';
    }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            svg {\n                margin-right: 4px;\n            }\n        "], ["\n            svg {\n                margin-right: 4px;\n            }\n        "])));
});
var templateObject_1, templateObject_2;

export { ChipWrapper };
//# sourceMappingURL=Chip.css.js.map
